export default __webpack_public_path__ + "static/friend_01-5087078cb08b469abe0397a474b47a46.png";